//This class defines search parameters.
export class SearchParms {
    Name: string = "";
    City: string = "";
    State: string = "";
    ZipCode: string = "";
    Level: string = "";
    LevelAssignedby: string = "";
    NumberofBeds: string = "";
}